import { motion } from "framer-motion";

interface WaveProps {
  className?: string;
  fill?: string;
  flip?: boolean;
}

export default function Wave({ className = "", fill = "var(--color-foam-50)", flip = false }: WaveProps) {
  return (
    <div
      className={`pointer-events-none relative h-16 w-full overflow-hidden leading-none sm:h-24 ${
        flip ? "rotate-180" : ""
      } ${className}`}
    >
      <motion.svg
        viewBox="0 0 1440 120"
        className="absolute inset-0 h-full w-[220%]"
        preserveAspectRatio="none"
        animate={{ x: ["-2%", "0%", "-2%"] }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
      >
        <path
          d="M0,64 C240,120 480,0 720,32 C960,64 1200,120 1440,64 L1440,120 L0,120 Z"
          fill={fill}
          opacity={0.55}
        />
      </motion.svg>
      <motion.svg
        viewBox="0 0 1440 120"
        className="absolute inset-0 h-full w-[220%]"
        preserveAspectRatio="none"
        animate={{ x: ["0%", "-3%", "0%"] }}
        transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
      >
        <path
          d="M0,80 C220,20 480,100 720,60 C980,20 1200,90 1440,50 L1440,120 L0,120 Z"
          fill={fill}
        />
      </motion.svg>
    </div>
  );
}
